import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
	container: {
		display: 'flex',
		borderTop: '1px solid #EFF3F4',
	},
	messageComposerBox: {
		display: 'flex',
		width: '100%',
		margin: theme.spacing(1),
	},
	inputField: {
		padding: theme.spacing(1),
	},
	iconBtn: {
		height: 48,
	},
}));
